import { FC } from "react";
import ResetPasswordForm from "../../components/Form/ResetPassword";

const ResetPasswordPage: FC = () => {
  return <ResetPasswordForm onReset={() => {}} />;
};

export default ResetPasswordPage;
